<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0"> Remove Class and Grade</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <CCol sm="12" class="float-right text-right mt-3">
        <br />
        <span
          ><img src="../assets/img/iconInboxTeacher.png" width="40px" />
          <br /><span class="mr-1"></span
        ></span>
      </CCol>
      <div class="mt-5"><br /><br /><br /><br /><br /></div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
                  Remove Class and Grade
                </h5>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0 mt-2">
                      <CCol sm="12" lg="12">
                        <h5
                          class="text-left mt-2 d-flex d-sm-none text-black bold"
                        >
                          Class and Grade
                        </h5>
                        <br />
                        <CCard
                          v-for="item in TeacherClass"
                          v-bind:key="item.Id"
                          class="p-2"
                        >
                          <div class="custom-row">
                            <div class="custom-column-right">
                              <h3 style="background: #eef; padding: 10px">
                                {{ item.Name.charAt(0) }}
                              </h3>
                            </div>
                            <div class="custom-column">
                              <h5>{{ item.Name }}</h5>
                              <h6>
                                <div class="small text-muted">
                                  {{ item.Class }}
                                </div>
                              </h6>
                            </div>
                             <div class="custom-column-action">
                               <CButton
                          color="danger"
                          class=" ml-2 mr-2"
                          @click="Delete"
                          >X</CButton
                        >
                            </div>
                          </div>
                        </CCard>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      ProfessionalName: "",
      AreaOfExpertise: "",
      TeacherClass: [],
    };
  },
  async mounted() {
    await this.GetProfile();
    await this.GetTeacherClass();
  },

  methods: {
    async GetProfile() {
      return this.$API
        .get(this.$ProfessionalTeacher + "?userid=" + this.$route.query.userId)
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.ProfessionalName = this.info.ProfessionalName;
            this.AreaExpertise = this.info.AreaExpertise;
            this.TeacherId = this.info.TeacherId;
            this.ProfessionalId = this.info.ProfessionalId;
            this.AreaId = this.info.AreaId;
            console.log("t" + this.ProfessionalName);
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    async GetTeacherClass() {
      this.$API
        .get(this.$TeacherClassGrade + "?userid=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.TeacherClass = response.data;
          }
        });
    },
    GoToPageNewSubjectGrade() {
      this.$router.push("/NewSubjectGrade?userID=" + this.$route.query.userId);
    },
  },
};
</script>
